<template>
  <div
    aria-hidden="true"
    class="onboarding-modal modal fade animated"
    id="descripcionModal"
    role="dialog"
    tabindex="-1"
    style="padding-right: 15px"
    data-backdrop="static"
    data-keyboard="false"
    href="#"
  >
    <div class="modal-dialog modal-centered fade animated" role="document">
      <div class="modal-content text-center">
        <button
          aria-label="Close"
          class="close"
          type="button"
          @click="closeModal()"
        >
          <span class="close-label">Close</span
          ><span class="os-icon os-icon-close"></span>
        </button>
        <div class="onboarding-content with-gradient">
          <div class="onboarding-title text-left">
            <span class="font-weight-bold">Producto: </span>
            <span class="text-success" v-if="detalle.producto_obj">{{
              detalle.producto_obj.sku
            }}</span>
            <br />
            <span class="font-weight-bold">Existencia: </span>
            <span class="text-success" v-if="existencia">{{ existencia }}</span>
            <br />
            <span class="font-weight-bold">Cantidad Pickeada: </span>
            <span class="text-success" v-if="existencia">{{
              detalle.cant_pickeada
            }}</span>
          </div>
          <br />
          <div
            v-if="comentario_nopiking == true"
            class="text-left text-success"
          >
            <a @click="regresar()">
              <i class="fa fa-chevron-left"></i> Regresar</a
            >
            <br />
          </div>
          <div class="col-12" v-if="comentario_nopiking == true">
            <br />
            <label>Motivo por el cual retorna el producto pickeado</label>
            <textarea
              cols="30"
              rows="3"
              class="form-control"
              v-model="detalle.obs_motivo_no_pick"
            ></textarea>
            <small
              v-if="error && error.obs_motivo_no_pick"
              class="text-danger"
              >{{ error.obs_motivo_no_pick[0] }}</small
            >
          </div>
          <br />
          <!-- <button
            @click="comentario_nopiking = true"
            v-if="comentario_nopiking == false"
            class="btn btn-danger btn-block"
          >
            Retorno de producto
          </button>
          <button
            v-if="comentario_nopiking == true"
            class="btn btn-danger btn-block"
            @click="generarRetornoPicking()"
          >
            Generar retorno
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      motivos: [],
      comentario_nopiking: false,
      error: [],
    };
  },
  props: ["detalle", "current", "existencia"],
  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    // generarRetornoPicking() {
    //   let self = this;
    //   DynamicService.postAction(
    //     "wms",
    //     "tareas",
    //     self.current.id,
    //     "limpiar_detalle_picking",
    //     {
    //       id: self.detalle.id,
    //       obs_motivo_no_pick: self.detalle.obs_motivo_no_pick,
    //     }
    //   )
    //     .then((response) => {
    //       Notifications.alert.success(
    //         "Retornar producto pickeado",
    //         "Realizado Exitosamente"
    //       );
    //       self.closeModal();
    //       self.$emit("refresh");
    //     })
    //     .catch((error) => {
    //       self.error = error.response.data;
    //       if (error.response.data && error.response.data.detail) {
    //         Notifications.alert.error(
    //           "Retornar producto pickeaDo",
    //           error.response.data.detail
    //         );
    //       }
    //     });
    // },
    regresar() {
      let self = this;
      self.comentario_nopiking = false;
      self.error = "";
    },
    closeModal() {
      let self = this;
      $("#descripcionModal").modal("hide");
      self.regresar();
    },
  },
};
</script>
